import { ButtonTypes } from "../../../../../../components/ui/Button";
import { Icon, IconSymbols } from "../../../../../../components/ui/Icon";
import { UiSizes } from "../../../../../../enums";
import Pages from "../../../../../../routes/InsightRoutes";
import I18n from "../../../../../localization/I18n";
import { UiActionRenderers } from "../../../../../uiAction/IUiAction";
import { GridActionEnum, GridLinkActionEnum } from "../../../enums/GridActionEnum";
import { ImpactsGridModel } from "./ImpactsGridView_model";

export const GetImpactsGridActions = (model: ImpactsGridModel) => {
  return [
    {
      id: "name",
      label: I18n.t("phrases.add"),
      componentProps: {
        symbol: IconSymbols.Plus
      },
      type: "microForm",
      contextProps: {
        formModel: model.microImpactForm,
        onSubmit: model.createMicroImpact
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.review,
      label: I18n.t("phrases.review"),
      type: "uiAction",
      onAction: ev => model.showImpactConfirmReviewModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.CommentPencil
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.email,
      label: I18n.t("phrases.email"),
      type: "uiAction",
      onAction: ev => model.showEmailsModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Mail
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.link,
      label: (
        <>
          <Icon symbol={IconSymbols.Link} size={UiSizes.MD} />
          <Icon symbol={IconSymbols.ChevronDown} size={UiSizes.SM} />
        </>
      ),
      type: "uiAction",
      componentProps: {
        type: ButtonTypes.LINK,
        className: "p-1"
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON,
      children: [
        {
          id: GridLinkActionEnum.linkStakeholders,
          label: I18n.t("phrases.stakeholders"),
          type: "uiAction",
          onAction: ev => model.showLinkToStakeholders(),
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkActions,
          label: I18n.t("phrases.actions"),
          type: "uiAction",
          onAction: ev => model.showLinkToActions(),
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkProcesses,
          label: I18n.t("phrases.processes"),
          type: "uiAction",
          onAction: ev => model.showLinkToProcesses(),
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkLocations,
          label: I18n.t("phrases.locations"),
          type: "uiAction",
          onAction: ev => model.showLinkToLocations(),
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkBusinessAreas,
          label: I18n.t("entities.businessAreas"),
          type: "uiAction",
          onAction: async ev => {
            model.showLinkToBusinessAreas();
          },
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkImpactGroups,
          label: I18n.t("entities.impactGroups"),
          type: "uiAction",
          onAction: async ev => {
            model.showLinkToImpactGroups();
          },
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        },
        {
          id: GridLinkActionEnum.linkTags,
          label: I18n.t("entities.tags"),
          type: "uiAction",
          onAction: async ev => {
            model.showLinkToTags();
          },
          componentProps: {
            type: ButtonTypes.LINK
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        }
      ]
    },
    {
      id: GridActionEnum.delete,
      label: I18n.t("phrases.delete"),
      type: "uiAction",
      onAction: ev => model.showImpactConfirmDeleteModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Trash
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.duplicate,
      label: I18n.t("phrases.duplicate"),
      type: "uiAction",
      onAction: ev => model.duplicateItems(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Copy
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.bulkEdit,
      label: I18n.t("phrases.bulkEdit"),
      type: "uiAction",
      onAction: ev => model.showBulkEditModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Edit3
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.export,
      label: I18n.t("phrases.export"),
      type: "uiAction",
      onAction: ev => model.exportRows(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Download
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.upload,
      label: I18n.t("phrases.upload"),
      type: "uiAction",
      onAction: ev => model.showUploaderModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Upload
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: "devider",
      label: "",
      type: "devider",
      onAction: ev => {},
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.textWrap,
      label: I18n.t("phrases.textWrap"),
      type: "uiAction",
      onAction: ev => {
        model.textWrapAddon.toggleTextWrap();
        model.generateActions();
      },
      componentProps: {
        type: model.textWrapAddon.isWrappedText ? ButtonTypes.PRIMARY : ButtonTypes.OUTLINE_PRIMARY,
        symbol: IconSymbols.TextWrap
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.clearFilters,
      label: I18n.t("phrases.clearFilters"),
      type: "uiAction",
      disabledWhenNoItemSelected: false,
      onAction: ev => {
        model.filterStoreAddon.clearFilters();
        model.navigate(Pages.projects.impacts.listView.generateLink(model.organisationId, model.projectId), {
          replace: true
        }); // to clear the query params
      },
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.ClearFilter,
        isDisabled: !model.isFilterChanged
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.resetColumns,
      label: I18n.t("phrases.resetColumns"),
      type: "uiAction",
      disabledWhenNoItemSelected: false,
      onAction: ev => {
        model.columnStateAddon.resetColumns();
      },
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.MonitorBack,
        isDisabled: !model.isColumnStateChanged
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    }
  ];
};
